import { showExperimentalFeatures } from 'pages/raas/DeploymentDetails/helpers/visibility';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { PATHS } from 'routes';

export const ExperimentalFeaturesGuard: React.FC<PropsWithChildren> = ({ children }) => {
  return showExperimentalFeatures ? <>{children}</> : <Navigate to={PATHS.DEFAULT} />;
};
